import { MemberRole } from '@stytch/vanilla-js'
import { Role } from '@/service-library/hooks/auth-user'

const HIDDEN_ROLE_IDS = ['stytch_member', 'stytch_admin']

export function isRoleVisibleInUI(roleId: string) {
  return !HIDDEN_ROLE_IDS.includes(roleId) && !roleId.startsWith('PD ')
}

export const DEFAULT_USER_ROLE = {
  id: 'User',
  description: 'Can view and manage documents this user has uploaded.',
  order: 0,
  is_assignable: true,
}

export function getHighestRole(
  stytchRoles: MemberRole[],
  rolesMap: Map<string, Role>,
) {
  let highestRole: Role = DEFAULT_USER_ROLE
  for (const memberRole of stytchRoles) {
    if (!isRoleVisibleInUI(memberRole.role_id)) continue
    const role = rolesMap.get(memberRole.role_id)
    if (role && role.order > highestRole.order) {
      highestRole = role
    }
  }
  return highestRole
}
